import React from "react"

import Layout from "../layout/layout"
import SEO from "../components/seo"
import Hero from './../components/hero/hero';
import MenuMobile from './../components/menuMobile/menuMobile';
import Bio from './../components/bio/bio';
import Technologies from '../components/technologies/technologies';
import Projects from './../components/projects/projects';
import Footer from "../components/footer/footer";

const IndexPage = () => {

  return (
  <Layout>

    <SEO title="Lester-Barahona" />

    <Hero/>

    <Bio />

    <Technologies/>

    <Projects/>


    <Footer/>

    <MenuMobile/>

  </Layout>
  )
}

export default IndexPage
